import { cn } from "../../lib/utils";
import { usePatientsVisits } from "../../lib/hooks/doctors/use-patient-visits";
import { useDoctorsList } from "../../lib/hooks/doctors/use-doctors-list";
import Nav from "./nav";
import DoctorCard from "./doctor-card";
import PatientVisitsCard from "./patient-visits-card";
import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/auth-context";
import UpcomingAppointments from "./upcoming-appointments";
import { Link } from "react-router-dom";
import { Button, buttonVariants } from "../../components/ui/button";
import SearchIcon from "../../components/search-icon";
import { usePatientHealthRecords } from "../../lib/hooks/doctors/use-patient-health-records";
import HealthRecordCard from "./health-record-card";
import SpecialtyList from "./SpecialtyList";
import { useNavigate } from "react-router-dom";
import Appointment from './appointment-details';

const MAX_ENTITY = 5;

function DoctorsPage() {
  const storedPatient = localStorage.getItem("selectedPatient");
  const [selectedPatient, setSelectedPatient] = useState(storedPatient);

  const { mobile, fetched } = useAuth();
  const [page, setPage] = useState(0);
  const navigate = useNavigate()


  const {
    visitsInfo = [],
    isLoading: isVisitsLoading,
    isFetched: isVisitsFetched,
  } = usePatientsVisits({
    selectedPatient,
  });

  const areVisitsAvailable = isVisitsFetched && visitsInfo.length > 0;

  const { doctors = [], isLoading: isDoctorsLoading, totalPages, totalItems } = useDoctorsList({
    enabled: fetched && !isVisitsLoading && !areVisitsAvailable,
    page,
    size: MAX_ENTITY,
  });

  const { healthRecords = [] } = usePatientHealthRecords({
    name: selectedPatient ?? "",
    mobile: mobile ?? "",
  });

  // console.log("health records are :", healthRecords);

  const [paginatedVisits, setPaginatedVisits] = useState(
    visitsInfo.slice(0, MAX_ENTITY),
  );

  const [paginatedHealthRecords, setPaginatedHealthRecords] = useState(
    healthRecords.slice(0, MAX_ENTITY),
  );

  useEffect(() => {
    if (
      Array.isArray(visitsInfo) &&
      paginatedVisits.length !== visitsInfo.slice(0, MAX_ENTITY).length
    ) {
      setPaginatedVisits(visitsInfo.slice(0, MAX_ENTITY));
    }
  }, [visitsInfo]);

  useEffect(() => {
    if (
      Array.isArray(healthRecords) &&
      paginatedHealthRecords.length !== healthRecords.slice(0, MAX_ENTITY).length
    ) {
      setPaginatedHealthRecords(healthRecords.slice(0, MAX_ENTITY));
    }
  }, [healthRecords]);


  return (
    <div className="container">
      <Nav
        selectedPatient={selectedPatient}
        setSelectedPatient={setSelectedPatient}
      />
      <main className="py-2">
        <Link to="/doctors-list">
          <div className="flex h-14 items-center justify-between rounded-md bg-muted px-3">
            <p className="text-muted-foreground">Search a doctor</p>
            <SearchIcon className="text-muted-foreground" />
          </div>
        </Link>
        {(areVisitsAvailable || !!healthRecords.length) && (
          <Link
            to="/doctors-list"
            className="mt-4 inline-block text-sm font-bold text-primary underline"
          >
            Find available doctors
          </Link>
        )}
        <UpcomingAppointments selectedPatient={selectedPatient} />
        <div className="mt-4">
          {areVisitsAvailable ? (
            <div className="mb-2 flex items-center justify-between sm:mb-4">
              <h2 className="font-bold sm:text-lg">Last Visits</h2>
              {visitsInfo.length > MAX_ENTITY &&
                paginatedVisits.length !== visitsInfo.length && (
                  <Button
                    variant="link"
                    className="text-xs !font-bold sm:text-sm"
                    onClick={() => setPaginatedVisits(visitsInfo)}
                  >
                    View all visits
                  </Button>
                )}
            </div>
          ) : (
            !healthRecords.length && (
              <div className="flex flex-col gap-4">
              <div className="flex flex-col md:flex-row gap-4">
                {/* <div className="rounded-lg border-4 border-gray-200 bg-gray-50 p-5 text-gray-500 w-full md:w-[400px]">
                  <h2 className="mb-2 text-sm font-bold md:text-xl">
                    No Upcoming Visits
                  </h2>
                  <p className="text-sm font-bold md:text-lg opacity-60">
                    Schedule your next appointment
                  </p>
                  <p className="text-xs opacity-60 sm:text-sm mt-2">
                    Book with available doctors
                  </p>
                </div> */}
                <div className="rounded-lg border-4 border-gray-200 bg-gray-50 p-5 text-gray-500 w-full md:w-[400px]">
                  <h2 className="mb-2 text-sm font-bold md:text-xl">
                    No Previous Visits
                  </h2>
                  <p className="text-sm font-bold md:text-lg opacity-60">
                    Your visit history will appear here
                  </p>
                  <p className="text-xs opacity-60 sm:text-sm mt-2">
                    After your first appointment
                  </p>
                </div>
              </div>
              <Button
                onClick={() => navigate("/doctors-list")}
                className="w-full sm:w-auto sm:max-w-sm sm:mx-auto h-12 bg-[#008080] hover:bg-[#006666] text-white font-bold text-base sm:text-lg sm:px-8">
                                  Book Appointment
              </Button>
            </div>
            )
          )}
          <ul
            className={cn(
              "grid max-sm:divide-y sm:gap-2 md:grid-cols-2 lg:gap-4 xl:grid-cols-3 2xl:grid-cols-4",
              {
                "md:grid-cols-3 2xl:grid-cols-3": areVisitsAvailable,
              },
            )}
          >
            {areVisitsAvailable ? (
              isVisitsLoading ? (
                <p>Loading...</p>
              ) : (
                paginatedVisits.map((visit) => (
                  <PatientVisitsCard
                    key={visit.doctorInfo.professionalId}
                    {...visit}
                    selectedPatient={selectedPatient}
                  />
                ))
              )
            ) : !healthRecords.length && isDoctorsLoading ? (
              <p>Loading...</p>
            ) : (
              !healthRecords.length &&
            
            <></>
            )}
          </ul>
        </div>
        {!!healthRecords.length && (
          <div className="mt-4">
            <div className="mb-2 flex items-center justify-between sm:mb-4">
              <h2 className="font-bold sm:text-lg">Uploaded Health Records</h2>
              {healthRecords.length > MAX_ENTITY &&
                paginatedHealthRecords.length !== healthRecords.length && (
                  <Button
                    variant="link"
                    className="text-xs !font-bold sm:text-sm"
                    onClick={() => setPaginatedHealthRecords(healthRecords)}
                  >
                    View all records
                  </Button>
                )}
            </div>
            <ul
              className={cn(
                "grid gap-4 sm:gap-2 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4",
                {
                  "md:grid-cols-3 2xl:grid-cols-3": areVisitsAvailable,
                },
              )}
            >
              {Array.isArray(paginatedHealthRecords) ? (
                paginatedHealthRecords.map((record) => (
                  <HealthRecordCard key={record.recordId} {...record} />
                ))
              ) : (
                <p>No health records available.</p>
              )}
            </ul>
          </div>
        )}
      </main>
    </div>
  );
}

export default DoctorsPage;
